import { defineMessages } from 'react-intl'

export default defineMessages({
  paginationState: {
    defaultMessage: '{from} - {to} of {recordsCount}',
    description: 'pagination | current state of pagination',
  },
  rowsPerPage: {
    defaultMessage: 'Rows per page',
    description: 'pagination | rows per page text',
  },
})
